import Rete from 'rete';

import VueDistPreview from '../../components/commons/VueDistPreview';


export default class DistPreviewControl extends Rete.Control {

	constructor(emitter, key, readonly, nodeID) { 
		super(key);
		this.component = VueDistPreview;
		this.props = { emitter, ikey: key, readonly, nodeID: nodeID};
	}

	setValue(val) {

		// This function just sends the values to the VueDistPreview and writes it into the arrayvalues
		this.vueContext.arrayvalues = val;
	}
}
